// Module
var code = "<h2 id=\"payment-related-forms\">Payment Related Forms</h2> <p>Repay your loan in a way that is most convenient for you.</p> ";
// Exports
export default code;